import { useMutation } from '@tanstack/react-query'
import { useSelector } from 'react-redux'
import { App } from 'antd'
import { useTranslation } from 'react-i18next'
import { contextCompanyIdSelector } from '../../../redux/context/company/selectors'
import voucherQueryKeys from './voucherQueryKeys'
import { createVoucher } from '../service/voucherService'
import { queryClient } from '../../../services/api/queryClient'

export const useCtxCreateVoucher = () => {
  const companyId = useSelector(contextCompanyIdSelector)!
  const { notification, message } = App.useApp()
  const { t } = useTranslation()

  if (!companyId) {
    throw new Error('Company ID is required for vouchers.')
  }

  return useMutation({
    mutationKey: voucherQueryKeys.list({ companyId }),
    mutationFn: (data: FormData) => createVoucher(data, companyId),
    onSuccess() {
      message.success(t('messages:createSuccess', 'Success'))
      return queryClient.invalidateQueries({
        queryKey: voucherQueryKeys.lists()
      })
    },
    onError(error) {
      notification.error({ message: error.message })
    }
  })
}
